import React from 'react'
import { string } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { errorViewMessages as messages } from './messages'

const ErrorView = ({ site, query }) => {
  const siteDomain = site === 'us' ? '' : '/' + site
  const querySearch = query ? `&q=${query}` : ''
  return (
    <div className='error-container'>
      <div className='error-main-text'>
        <h1 className='error-main-text__title'>
          <FormattedMessage {...messages.title} />
        </h1>
        <h3 className='error-main-text__subtitle'>
          <FormattedMessage {...messages.subtitle} />.
        </h3>
      </div>
      <div className='error_options__left'>
        <a className='afd-btn' href='/'>
          <FormattedMessage {...messages.btnText} /> <span style={{ marginLeft: '16px' }}>&#8594;</span>
        </a>
      </div>
      <div className='error-options__center'>
        <div className='vr' />
        <div className='error-options__center-text'>
          <FormattedMessage {...messages.or} />
        </div>
        <div className='vr' />
      </div>
      <div className='error_options__right'>
        <h3>
          <FormattedMessage {...messages.checkLatest} />:
        </h3>
        <ul className='error_options__latest'>
          <li>
            <a href={`${siteDomain}/search/projects`}>
              <FormattedMessage {...messages.projects} />
            </a>
          </li>
          <li>
            <a href={`${siteDomain}/search/architecture_news`}>
              <FormattedMessage {...messages.news} />
            </a>
          </li>

          {site !== 'cn' && (
            <li>
              <a href={`${siteDomain}/search/articles${querySearch}`}>
                <FormattedMessage {...messages.articles} />
              </a>
            </li>
          )}
          {site !== 'cn' && (
            <li>
              <a href={`/catalog${siteDomain}`}>
                <FormattedMessage {...messages.products} />
              </a>
            </li>
          )}
          <li>
            <a href={`${siteDomain}/competitions`}>
              <FormattedMessage {...messages.competitions} />
            </a>
          </li>
          {site !== 'cn' && (
            <li>
              <a href={`${siteDomain}/events`}>
                <FormattedMessage {...messages.events} />
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}

ErrorView.propTypes = {
  site: string,
  query: string
}

export default ErrorView
